var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUiArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24.001 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 144544",
  fill: "none",
  d: "M.001 0h24v24h-24z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.899 13.045H1.231a1.191 1.191 0 01-.877-.354A1.191 1.191 0 010 11.814a1.192 1.192 0 01.354-.877 1.192 1.192 0 01.877-.353h18.668L11.415 2.1a1.157 1.157 0 01-.361-.857 1.219 1.219 0 01.387-.873 1.286 1.286 0 01.865-.369 1.148 1.148 0 01.865.369l10.406 10.406a1.361 1.361 0 01.325.486 1.577 1.577 0 01.095.552 1.577 1.577 0 01-.095.552 1.361 1.361 0 01-.325.486L13.171 23.258a1.175 1.175 0 01-.844.349 1.227 1.227 0 01-.885-.349 1.206 1.206 0 01-.382-.877 1.206 1.206 0 01.382-.877z",
  fill: "#f96506"
})));
export default __webpack_public_path__ + "static/UI-arrow-right.49b559a045b7f966d347efecca307823.svg";
export { SvgUiArrowRight as ReactComponent };